import { useEffect, useRef, useState } from "react";

// Hook
export function useDebounce<T>(value: T, delay: number) {
    // State and setters for debounced value
    const [debouncedValue, setDebouncedValue] = useState(value);
    const handler = useRef<NodeJS.Timeout>();
    useEffect(
        () => {
            // Update debounced value after delay
            if(handler.current == null){
                setDebouncedValue(value);
            }

            handler.current = setTimeout(() => {
                setDebouncedValue(value);

                handler.current = undefined;
            }, delay);
            // Cancel the timeout if value changes (also on delay change or unmount)
            // This is how we prevent debounced value from updating if value is changed ...
            // .. within the delay period. Timeout gets cleared and restarted.
            return () => {
                if(handler.current != null){
                    clearTimeout(handler.current);
                }
            };
        },
        [value, delay] // Only re-call effect if value or delay changes
    );
    return debouncedValue;
}